"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TimelinesHelpers_1 = require("./TimelinesHelpers");
var TimelineHandler = function (_a) {
    var _b, _c;
    var disabled = _a.disabled, className = _a.className, value = _a.value, onChange = _a.onChange, onSelectedRange = _a.onSelectedRange, zoom = _a.zoom;
    var _d = __read((0, react_1.useState)(false), 2), moving = _d[0], setMoving = _d[1];
    var _e = __read((0, react_1.useState)(value || 0), 2), position = _e[0], setPosition = _e[1];
    var _f = __read((0, react_1.useState)(28), 2), width = _f[0], setWidth = _f[1];
    var handleRef = (0, react_1.useRef)(null);
    var left = ((_c = (_b = handleRef.current) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().left) || 0;
    (0, react_1.useEffect)(function () {
        if (!moving && value !== undefined && value !== null) {
            setPosition(value);
        }
    }, [moving, value]);
    (0, react_1.useEffect)(function () {
        var w = (0, TimelinesHelpers_1.scaleNumber)(1 - zoom);
        setWidth(w);
    }, [zoom]);
    (0, react_1.useEffect)(function () {
        var mouseUpHandler = function () {
            if (moving && onSelectedRange) {
                onSelectedRange(width);
            }
            setMoving(false);
        };
        var mouseMoveHandler = function (e) {
            var _a, _b;
            if (moving) {
                var totalWidth = ((_b = (_a = handleRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
                var x = e.clientX;
                var newPosition_1 = (x - left) / totalWidth;
                if (newPosition_1 < 0) {
                    newPosition_1 = 0;
                }
                if (newPosition_1 > 1) {
                    newPosition_1 = 1;
                }
                setPosition(function (prevState) {
                    if (prevState !== newPosition_1) {
                        onChange(newPosition_1);
                    }
                    return newPosition_1;
                });
            }
        };
        document.addEventListener("mouseup", mouseUpHandler);
        document.addEventListener("mousemove", mouseMoveHandler);
        return function () {
            document.removeEventListener("mouseup", mouseUpHandler);
            document.removeEventListener("mousemove", mouseMoveHandler);
        };
    }, [moving, onChange]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-slider", disabled && "disabled", className) },
        react_1.default.createElement("div", { ref: handleRef, className: "ui-slider-handle handler", role: "slider", onMouseDown: function (e) {
                if (!disabled) {
                    setMoving(true);
                }
                e.preventDefault();
            }, style: {
                left: "".concat(position * 100, "%"),
                width: "".concat(width, "px"),
            } },
            react_1.default.createElement("div", { className: "top" }),
            react_1.default.createElement("div", { className: "center" },
                react_1.default.createElement("div", { className: "left" }),
                react_1.default.createElement("div", { className: "right" })),
            react_1.default.createElement("div", { className: "bottom" },
                react_1.default.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { d: "M10 7.5C10 7.775 9.90217 8.01033 9.7065 8.206C9.51083 8.40167 9.27533 8.49967 9 8.5C8.725 8.5 8.48967 8.402 8.294 8.206C8.09833 8.01 8.00033 7.77467 8 7.5C8 7.225 8.098 6.9895 8.294 6.7935C8.49 6.5975 8.72533 6.49967 9 6.5C9.275 6.5 9.5105 6.59783 9.7065 6.7935C9.9025 6.98917 10.0003 7.22467 10 7.5ZM10 4.5C10 4.775 9.90217 5.01033 9.7065 5.206C9.51083 5.40167 9.27533 5.49967 9 5.5C8.725 5.5 8.48967 5.402 8.294 5.206C8.09833 5.01 8.00033 4.77467 8 4.5C8 4.225 8.098 3.9895 8.294 3.7935C8.49 3.5975 8.72533 3.49967 9 3.5C9.275 3.5 9.5105 3.59783 9.7065 3.7935C9.9025 3.98917 10.0003 4.22467 10 4.5ZM7 7.5C7 7.775 6.90217 8.01033 6.7065 8.206C6.51083 8.40167 6.27533 8.49967 6 8.5C5.725 8.5 5.48967 8.402 5.294 8.206C5.09833 8.01 5.00033 7.77467 5 7.5C5 7.225 5.098 6.9895 5.294 6.7935C5.49 6.5975 5.72533 6.49967 6 6.5C6.275 6.5 6.5105 6.59783 6.7065 6.7935C6.9025 6.98917 7.00033 7.22467 7 7.5ZM7 4.5C7 4.775 6.90217 5.01033 6.7065 5.206C6.51083 5.40167 6.27533 5.49967 6 5.5C5.725 5.5 5.48967 5.402 5.294 5.206C5.09833 5.01 5.00033 4.77467 5 4.5C5 4.225 5.098 3.9895 5.294 3.7935C5.49 3.5975 5.72533 3.49967 6 3.5C6.275 3.5 6.5105 3.59783 6.7065 3.7935C6.9025 3.98917 7.00033 4.22467 7 4.5ZM4 7.5C4 7.775 3.90217 8.01033 3.7065 8.206C3.51083 8.40167 3.27533 8.49967 3 8.5C2.725 8.5 2.48967 8.402 2.294 8.206C2.09833 8.01 2.00033 7.77467 2 7.5C2 7.225 2.098 6.9895 2.294 6.7935C2.49 6.5975 2.72533 6.49967 3 6.5C3.275 6.5 3.5105 6.59783 3.7065 6.7935C3.9025 6.98917 4.00033 7.22467 4 7.5ZM4 4.5C4 4.775 3.90217 5.01033 3.7065 5.206C3.51083 5.40167 3.27533 5.49967 3 5.5C2.725 5.5 2.48967 5.402 2.294 5.206C2.09833 5.01 2.00033 4.77467 2 4.5C2 4.225 2.098 3.9895 2.294 3.7935C2.49 3.5975 2.72533 3.49967 3 3.5C3.275 3.5 3.5105 3.59783 3.7065 3.7935C3.9025 3.98917 4.00033 4.22467 4 4.5Z", fill: "#333333" }))))));
};
exports.default = TimelineHandler;
